import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/0b193c8d-4137-471a-b4d4-be4073dc15c4";
export const REGISTER_URL = "https://a.ntrk2.com/9ba95fe1-bab3-49cd-936b-94a14e2964ea";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://yeswinph.kzw2a.com/download?openExternalBrowser=1&id=pcs8s3wye4g03rj";

export * from "./codes";
export * from "./context";
